import React from 'react';
import { Link } from 'react-router-dom';
import { theme } from '../theme';
import KeyIcon from '@mui/icons-material/Key';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SecurityIcon from '@mui/icons-material/Security';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import OptimizedImage from '../components/OptimizedImage';
import './Home.css';

const Home = () => {
  const navButtons = [
    { 
      path: '/access', 
      title: 'Accesos e Información', 
      icon: <KeyIcon sx={{ fontSize: 24 }} />
    },
    { 
      path: '/guide', 
      title: 'Guía del Departamento', 
      icon: <MenuBookIcon sx={{ fontSize: 24 }} />
    },
    { 
      path: '/security', 
      title: 'Seguridad y Emergencias', 
      icon: <SecurityIcon sx={{ fontSize: 24 }} />
    },
    { 
      path: '/calendar', 
      title: 'Calendario de Visitas', 
      icon: <CalendarMonthIcon sx={{ fontSize: 24 }} />
    },
  ];

  return (
    <div className="home-container">
      <div className="home-layout">
        <div className="hero-image-wrapper">
          <OptimizedImage
            src="/depa-image.jpg"
            srcSet="/depa-image-mobile.jpg 800w, /depa-image.jpg 1200w"
            sizes="(max-width: 768px) 100vw, 50vw"
            alt="Departamento Morales-Autrique"
            className="hero-image"
          />
        </div>
        
        <div className="content-side">
          <div className="welcome-section">
            <h1>Bienvenido a nuestro depa</h1>
            <p className="welcome-text">
              Encuentra aquí toda la información para tu visita.
            </p>
          </div>

          <div className="navigation-grid">
            {navButtons.map((button) => (
              <Link 
                key={button.path} 
                to={button.path} 
                className="nav-card"
              >
                <div className="card-icon-wrapper">
                  {button.icon}
                </div>
                <div className="card-content">
                  <span className="card-title">{button.title}</span>
                </div>
              </Link>
            ))}
            <a 
              href="https://finanzas.moralesautrique.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="nav-card"
            >
              <div className="card-icon-wrapper">
                <AccountBalanceIcon sx={{ fontSize: 24 }} />
              </div>
              <div className="card-content">
                <span className="card-title">Finanzas</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home; 